import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation.ts';
import type { WebItemLocationQueryType } from '@confluence/web-item-location/entry-points/WebItemLocationQuery.ts';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';

import { getGlobalAppsParams } from './getGlobalAppsParams.ts';
import type { GraphQLError } from 'graphql';

export const preloadGlobalApps = async (): Promise<void | {
	data: WebItemLocationQueryType | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> => {
	const { edition, accessStatus } = getPreloaderFnContext();

	const { webItemParams } = getGlobalAppsParams({
		edition,
		accessStatus,
	});

	return preloadWebItemLocation(webItemParams);
};
